var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router_container"},[_c('Transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }